import { render, staticRenderFns } from "./ClientCompanies.vue?vue&type=template&id=c5be2ba8"
import script from "./ClientCompanies.vue?vue&type=script&lang=js"
export * from "./ClientCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports